import script from "./HeaderTechnopolis.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderTechnopolis.vue?vue&type=script&setup=true&lang=js"

import "./HeaderTechnopolis.vue?vue&type=style&index=0&id=447bb80d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-447bb80d"]])

export default __exports__